import lf from 'lovefield'

export function simuexo_cubatures (schemaBuilder) {
  schemaBuilder.createTable('simuexo_cubatures')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('exo_chantiers_id', lf.Type.INTEGER)
      .addColumn('const_cubaturestypes_id', lf.Type.INTEGER)
      .addColumn('kmdebut', lf.Type.NUMBER)
      .addColumn('kmfin', lf.Type.NUMBER)
      .addColumn('description', lf.Type.STRING)
      .addPrimaryKey(['id'], true); // true == autoincrement
}





// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuexoCubatures.schema.js